/* eslint-disable guard-for-in */
/* eslint-disable quote-props */
/* eslint-disable quotes */

const htmlMap = {
  "&apos;": "'",
  "&lt;": "&lt;",
  "&gt;": "&gt;",
  "&nbsp;": " ",
  "&copy;": "©",
  "&laquo;": "«",
  "&raquo;": "»",
  "&frac14;": "¼",
  "&frac12;": "½",
  "&frac34;": "¾",
  "&Agrave;": "À",
  "&Aacute;": "Á",
  "&Acirc;": "Â",
  "&Atilde;": "Ã",
  "&Auml;": "Ä",
  "&Aring;": "Å",
  "&AElig;": "Æ",
  "&Ccedil;": "Ç",
  "&Egrave;": "È",
  "&Eacute;": "É",
  "&Ecirc;": "Ê",
  "&Euml;": "Ë",
  "&Igrave;": "Ì",
  "&Iacute;": "Í",
  "&Icirc;": "Î",
  "&Iuml;": "Ï",
  "&Ntilde;": "Ñ",
  "&Ograve;": "Ò",
  "&Oacute;": "Ó",
  "&Ocirc;": "Ô",
  "&Otilde;": "Õ",
  "&Ouml;": "Ö",
  "&Ugrave;": "Ù",
  "&Uacute;": "Ú",
  "&Ucirc;": "Û",
  "&Uuml;": "Ü",
  "&agrave;": "à",
  "&aacute;": "á",
  "&acirc;": "â",
  "&atilde;": "ã",
  "&auml;": "ä",
  "&aring;": "å",
  "&ccedil;": "ç",
  "&egrave;": "è",
  "&eacute;": "é",
  "&ecirc;": "ê",
  "&euml;": "ë",
  "&igrave;": "ì",
  "&iacute;": "í",
  "&icirc;": "î",
  "&iuml;": "ï",
  "&ocirc;": "ô",
  "&ouml;": "ö",
  "&ugrave;": "ù",
  "&uacute;": "ú",
  "&ucirc;": "û",
  "&uuml;": "ü",
  "&tilde;": "˜",
  "&quot;": '"',
  "&amp;": "&"
};

export class HtmlEntities {
  static decode(str) {
    const regex = new RegExp(/&\w+;/, 'g');
    const found = str?.match(regex) || [];
    found.forEach((item) => {
      str = str.replace(item, htmlMap[item]);
    });
    return str;
  }
}
